import { render, staticRenderFns } from "./POS-Order.vue?vue&type=template&id=5334d917"
import script from "./POS-Order.vue?vue&type=script&lang=js"
export * from "./POS-Order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports